import cx from 'classnames';

export type TokenVariant = 'success' | 'info' | 'warning' | 'error' | 'primary' | 'muted';

export type Props = {
  variant: TokenVariant;
  children?: React.ReactNode;
  className?: string;
};

const variantClasses: Record<TokenVariant, string> = {
  success: 'bg-success-100 text-success-700',
  info: 'bg-info-50 text-info-800',
  warning: 'bg-warning-100 text-warning-700',
  error: 'bg-error-50 text-error-900',
  primary: 'bg-primary-50 text-primary-900',
  muted: 'bg-gray-100 text-gray-600',
};

export const Token = ({ variant, children, className }: Props): JSX.Element => {
  return (
    <span
      className={cx(
        className,
        variantClasses[variant],
        'text-xs md:text-sm rounded-full uppercase font-semibold py-[1px] px-8',
      )}
    >
      {children}
    </span>
  );
};
